import { isEmpty } from 'lodash';
import { useQuery } from '../useQuery';
import { getRegions } from '@dispatch/shared/services';

export const useGetRegions = ({
  tenantId,
  enabled = true,
}: {
  tenantId: string;
  enabled?: boolean;
}) => {
  return useQuery(['regions', tenantId], () => getRegions(tenantId), {
    enabled: enabled && !isEmpty(tenantId),
  });
};
